/* eslint-disable react/prop-types */
/* eslint-disable @typescript-eslint/camelcase */
/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import { NoItemRow, TizetiGIFLogoTable } from '../../../../utils/loader/loadingHelper';
// import { CommentMessageLogsProps } from './types';
import helpers from '../../../../utils/helpers';

const CommentLogsTable = ({ data, loading }) => {
  const colSpan = '10';
  const tableData =
    data && data.length ? (
      data.map((cust, i) => {
        const { customer_number, username, name, basestation, agent, mail, comment, details, time, phone } = cust;
        return (
          <tr>
            <td>{i + 1}</td>
            <td>{customer_number}</td>
            <td>{username}</td>
            <td>{name}</td>
            <td>{mail}</td>
            <td>{phone}</td>
            <td>{comment}</td>
            <td>{details}</td>
            <td>{basestation.toUpperCase()}</td>
            <td>{agent}</td>
            <td className="text-nowrap">{helpers.formatDateAndTime(time)}</td>
          </tr>
        );
      })
    ) : (
      <NoItemRow colSpan={colSpan} text="No Log" />
    );

  return (
    <div className="card x-panel mt-2 px-2">
      <div className="table-responsive content col-12">
        <table className="table">
          <thead>
            <tr className="text-nowrap">
              <th>#</th>
              <th>Customer Number</th>
              <th>MAC ID</th>
              <th>Name</th>
              <th>Customer Email</th>
              <th>Customer Phone</th>
              <th>Comment</th>
              <th>Details</th>
              <th>Basestation</th>
              <th>Staff</th>
              <th>Time</th>
            </tr>
          </thead>
          <tbody>{loading ? <TizetiGIFLogoTable colSpan={colSpan} /> : tableData}</tbody>
        </table>
      </div>
    </div>
  );
};

export default CommentLogsTable;
